

import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';

// Material helpers
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletContent from 'components/PortletContent';
import 'react-perfcascade/dist/react-perfcascade.css';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import CircularProgress from '@material-ui/core/CircularProgress';
//import {HarFileView} from 'react-perfcascade';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import TablePagination from '@material-ui/core/TablePagination'
import ElementsPlus from '../ElementsPlus'
import harData from '../ElementsPlus/example.har';
import {HarFileView} from 'react-perfcascade';
import styles from './styles';
import { withStyles } from '@material-ui/core/styles';
//import harData from './example.har';
import {getBaseElements} from '../../../../../services/getBaseElements'
// Component styles

import moment from 'moment'
import 'moment/locale/es'
import { TableCell } from '@material-ui/core';
moment.locale('es')
const dateMoment=((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))



class BaseDataElements extends Component {
    
    constructor(props) {
        //console.log(props)
        super(props);
        //console.log('base data elements fecha inicioo', props.dateBegin.format("YYYY-MM-DD H:mm:ss"))
        //console.log('fecha termino', props.dateFinal.format("YYYY-MM-DD H:mm:ss"))
        this.state = {
            isLoad:true,
            objective:this.props.objective,
            nodes:this.props.nodes,
            steps:this.props.steps,
            begin:this.props.dateBegin.format("YYYY-MM-DD H:mm:ss"),
            final:this.props.dateFinal.format("YYYY-MM-DD H:mm:ss"),
            dates:null,
            pages: 1,
            page: 0, 
            rowsPerPage: 10
        };
    }

    static getDerivedStateFromProps(props, state) {
        //console.log('derived')
        //console.log(props.dateBegin.format("YYYY-MM-DD H:mm:ss"), state.begin)
        //console.log(props.dateFinal.format("YYYY-MM-DD H:mm:ss"), state.final)
        if (props.dateBegin.format("YYYY-MM-DD H:mm:ss") !== state.begin||props.dateFinal.format("YYYY-MM-DD H:mm:ss")!==state.final) {
            return {
                isLoad:true,
                begin:props.dateBegin.format("YYYY-MM-DD H:mm:ss"),
                final:props.dateFinal.format("YYYY-MM-DD H:mm:ss"),
                dates:null
            }
        }
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        //console.log('update')
        if(prevProps.dateBegin.format("YYYY-MM-DD H:mm:ss")!== this.state.begin||prevProps.dateFinal.format("YYYY-MM-DD H:mm:ss")!== this.state.final){
            this.processData();
        }
    }
    componentDidMount() {
        this.processData();
    }

    getFetchs = (objective, nodes, begin, final, token, id_user) =>{
        //console.log('fetchs')
        return new Promise((resolve, reject) => {
            var List = []
            var fetches = []            
            nodes.forEach((value, key)=>{
                //console.log(value.monitor)
                var monitor_id=(value.monitor)
                //console.log('get')
                var getData=getBaseElements(objective, monitor_id, begin, final, token, id_user)
                fetches.push(                    
                    getData.then( data =>  { 
                        List[key] = {"fechas":data, "dataNodo":value}
                    })                    
                )
            })
            Promise.all(fetches).then(() => {
                resolve(List);
            })      
        });
    }
   
    processData = () => {
        //console.log('process availbaility')
        const { objective, nodes, begin, final}=this.state
        nodes.sort(function (a, b) {
            return (a.id_nodo - b.id_nodo);
        });
        let token = sessionStorage.getItem('key')
        let id_user = sessionStorage.getItem('user')
        var data =this.getFetchs(objective, nodes, begin, final, token, id_user)
        data.then( value=>{
            
            this.props.callbackFromParent(true)
            //console.log(value)
            this.setState({
                isLoad:false,
                dates:value
            })
        })
        
    }
    dataElements=(dates, steps, objective)=>{
        const {classes}=this.props
        const {rowsPerPage, page} = this.state
        var data=[]
        
        dates.fechas
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map(date=>{
            var dateData=((date.fecha.substr(0,19)).replace("T", " "))
            //console.log('fechas', date.fecha)
            data.push(
                <ExpansionPanel className={classes.backGrey2} key={date.fecha}>
                    <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id={date.fecha}
                    key={date.fecha}
                    >
                        <Typography className={classes.textWhite}>{dateData}</Typography>
                    </ExpansionPanelSummary>
                    <ElementsPlus steps={steps} date={date} objective={objective} node={dates.dataNodo}/>
                    
                </ExpansionPanel>
            )
        })
        return data
    }

    handleChangePage = (e, page)=>{
        this.setState({
            page : page
        })
    }

    render() {

        const { isLoad, dates, steps, objective, page, pages, rowsPerPage} = this.state;
        
        const { classes } = this.props;
        if (isLoad===true) {
            return(
                <div>
    
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"

                        size={12}
                        thickness={3}
                        
                    />
                        Cargando Información...
                    </Typography>
                </div>
            )
        }else{
            return(
                <PortletContent >
                {dates.map(dateNode=>(
                    <ExpansionPanel key={dateNode.dataNodo.id_nodo}>
                
                        <ExpansionPanelSummary
                        className={classes.backGrey}
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id={dateNode.dataNodo.id_nodo}
                        >
                            <Typography className={classes.textWhite}>{dateNode.dataNodo.nodo}</Typography>
                        </ExpansionPanelSummary>
                        {this.dataElements(dateNode, steps, objective)}
                        <TablePagination
                            style={{color:"white", backgroundColor:"#525252"}}
                            rowsPerPageOptions={[6]}
                            component="div"
                            count={dateNode.fechas.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelDisplayedRows={({ from, to, count }) => {return '' + from + '-' + to + ' de ' + count}}
                            backIconButtonProps={{
                                'aria-label': 'previous page',
                                'style': {'color': 'white'}
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'next page',
                                'style': {'color': 'white'}
                            }}
                            onChangePage={this.handleChangePage}/>
                    </ExpansionPanel>
                ))
                }
                </PortletContent>
                
            )
        }
    }
}



export default compose(withRouter, withStyles(styles))(BaseDataElements);